<section class="journal-panel">
  <ng-container *ngIf="view === 'list'; else editorView">
    <div class="journal-header">
      <div>
        <h3>Your journal</h3>
        <p class="subtitle">All your text notes and voice dictations in one place.</p>
      </div>
      <button type="button" class="btn btn-primary new-btn" (click)="openNewEntry()">
        <i class="bi bi-plus-lg"></i>
        New entry
      </button>
    </div>

    <div class="loading-state" *ngIf="isLoading && entries.length === 0">
      <div class="spinner" aria-hidden="true"></div>
      <span>Loading entries…</span>
    </div>

    <div class="error-state" *ngIf="loadError">
      <i class="bi bi-exclamation-triangle"></i>
      <span>{{ loadError }}</span>
      <button type="button" class="btn btn-secondary btn-sm" (click)="loadEntries()">Retry</button>
    </div>

    <div class="empty-state" *ngIf="!isLoading && !loadError && entries.length === 0">
      <i class="bi bi-journal-text"></i>
      <p>No journal entries yet.</p>
      <button type="button" class="btn btn-primary" (click)="openNewEntry()">
        Write your first entry
      </button>
    </div>

    <div
      class="entries-list"
      *ngIf="entries.length > 0"
      (scroll)="onEntriesScroll($event)">
      <button
        type="button"
        class="entry-card"
        *ngFor="let entry of entries"
        (click)="openEntry(entry)">
        <div class="entry-top">
          <span class="entry-title">{{ entryTitle(entry) }}</span>
          <span class="type-badge" [class.voice]="entry.type === 'AUDIO'">{{ typeLabel(entry) }}</span>
        </div>
        <p class="entry-preview" [class.muted]="isTranscribing(entry)">
          {{ entryPreview(entry) }}
        </p>
        <div class="entry-meta">
          <span>{{ entryDate(entry) }}</span>
          <span class="transcribing-pill" *ngIf="isTranscribing(entry)">
            <span class="mini-spinner" aria-hidden="true"></span>
            Transcribing
          </span>
        </div>
      </button>

      <div class="load-more-state" *ngIf="isLoadingMore">
        <span class="mini-spinner" aria-hidden="true"></span>
        <span>Loading older entries…</span>
      </div>

      <small class="end-hint" *ngIf="!hasMore && !isLoadingMore">
        You’ve reached the end of your journal.
      </small>
    </div>

    <small class="hint" *ngIf="hasTranscribingEntries">
      Voice notes appear here immediately and update when transcription finishes.
    </small>
  </ng-container>

  <ng-template #editorView>
    <app-contemplation-notes-panel
      [editingEntry]="editingEntry"
      [showBack]="true"
      (back)="backToList()"
      (entrySaved)="onEntrySaved()">
    </app-contemplation-notes-panel>
  </ng-template>
</section>
